import { Theme, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => ({
  card: {
    marginTop: '5%',
    marginRight: '1%',
    marginLeft: '1%',
    padding: 10,
    borderRadius: 10,
    height: 138,
    width: 290,
    backgroundColor: theme.palette.background.paper,
    boxShadow: '0px 2px 20px rgba(0, 0, 0, 0.2)',
    [theme.breakpoints.down('xs')]: {
      marginBottom: '5%',
      minHeight: 150,
      width: '90%',
    },
    [theme.breakpoints.down('sm')]: {
      marginBottom: '5%',
      minHeight: 150,
      width: '90%',
    },
  },
  cardImage: {
    width: 36,
    padding: 12,
  },
  description: {
    fontSize: 18,
    fontFamily: 'Inter',
    color: theme.palette.text.secondary,
    marginLeft: 10,
    lineHeight: '23px',
  },
  checkbox: {
    width: 24,
    marginLeft: -5,
  },
}));
